import Avatar from "../../../../../../components/Avatar";

export default function AvatarDisplay({ user, name, tooltipName }) {
    return (
      <Avatar
        title={tooltipName}
        className={"header-avatar add-comment-avtar"}
        user_image={user?.user_image}
        style={
          !user?.user_image && {
            bgcolor: user?.profile_color?.background,
            color: user?.profile_color?.text,
          }
        }
      >
        {name}
      </Avatar>
    );
  }